<div class="pu-page ro">
  <div class="pu-head">
    <div class="pu-head__main">
      <h1 class="stk-page-title">Beszerzési rendelések</h1>
      <div class="stk-page-sub">A beszállítói rendelések a jóváhagyástól a megérkezésig.</div>
    </div>
    <div class="ro-filters">
      <button type="button" class="pu-chip" [class.pu-chip--on]="filter === 'active'" (click)="setFilter('active')">Folyamatban</button>
      <button type="button" class="pu-chip" [class.pu-chip--on]="filter === 'received'" (click)="setFilter('received')">Megérkezett</button>
      <button type="button" class="pu-chip" [class.pu-chip--on]="filter === 'all'" (click)="setFilter('all')">Mind</button>
    </div>
  </div>

  <div class="pu-empty" *ngIf="loading">Betöltés…</div>
  <div class="pu-card pu-empty" *ngIf="!loading && !orders.length">
    Nincs {{ filter === 'active' ? 'folyamatban lévő ' : '' }}rendelés. <a class="pu-link" routerLink="/beszerzes">Rendelési lista →</a>
  </div>

  <div class="pu-card ro-card" *ngFor="let o of orders" [id]="'po-' + o.id" [class.ro-card--focus]="o.id === focusId">
    <div class="ro-card__head">
      <div class="ro-card__main">
        <div class="pu-card__title">
          <span class="ro-id">{{ o.displayId }}</span> {{ o.supplier?.name }}
          <span class="pu-pill" [ngClass]="'pu-pill--' + (o.supplier?.orderMethod || 'email')">{{ o.supplier?.orderMethod === 'webshop' ? 'webshop' : 'e-mail' }}</span>
        </div>
        <div class="pu-card__sub">
          {{ o.createdAt | date:'MMM d., HH:mm' }}
          <ng-container *ngIf="o.grossTotal !== null"> · ≈ {{ o.grossTotal | number:'1.0-0' }} Ft</ng-container>
          · {{ o.supplier?.paymentMethod }}
          <ng-container *ngIf="o.supplierOrderRef"> · rendelésszám: {{ o.supplierOrderRef }}</ng-container>
          <ng-container *ngIf="o.trackingCode"> · csomag: {{ o.trackingCode }}</ng-container>
          <ng-container *ngIf="o.autoSent"> · Foxi küldte</ng-container>
        </div>
      </div>
      <span class="pu-pill" [ngClass]="'pu-pill--' + o.status">{{ o.statusLabel }}</span>
    </div>

    <div class="ro-steps" *ngIf="o.status !== 'cancelled' && o.status !== 'pending' && o.status !== 'approved'">
      <ng-container *ngFor="let s of steps; let last = last">
        <span class="ro-step" [class.ro-step--done]="stepDone(o, s.status)">{{ s.label }}</span>
        <span class="ro-step__sep" *ngIf="!last">›</span>
      </ng-container>
    </div>

    <ul class="ro-items">
      <li *ngFor="let i of o.items">
        <b>{{ i.quantity }} db</b>
        <a *ngIf="i.url; else plain" [href]="i.url" target="_blank" rel="noopener">{{ i.name }}</a><ng-template #plain>{{ i.name }}</ng-template>
        <span class="pu-muted" *ngIf="i.supplierSku"> · {{ i.supplierSku }}</span>
        <span class="pu-muted" *ngIf="i.unitPrice !== null"> · {{ i.unitPrice | number:'1.0-2' }} Ft/db</span>
      </li>
    </ul>
    <div class="pu-muted ro-note" *ngIf="o.note">📝 {{ o.note }}</div>
    <div class="ro-robot" *ngIf="o.robotRun" [ngClass]="'ro-robot--' + o.robotRun.status">
      <span>{{ robotLabel(o) }}</span>
      <button type="button" class="pu-btn pu-btn--sm" *ngIf="o.robotRun.hasScreenshot && !shots[o.robotRun.id]" (click)="showShot(o)">Képernyőkép</button>
      <img *ngIf="shots[o.robotRun.id]" [src]="shots[o.robotRun.id]" alt="A robot képernyőképe" class="ro-shot">
    </div>

    <!-- levél-szerkesztő (e-mailes rendelés kézi küldése) -->
    <div class="ro-mail" *ngIf="mailEdit?.id === o.id">
      <label class="pu-field">Tárgy <input class="pu-input" [(ngModel)]="mailEdit!.subject"></label>
      <label class="pu-field">Levél <em>(az aláírás automatikusan a végére kerül)</em>
        <textarea class="pu-input" rows="9" [(ngModel)]="mailEdit!.body"></textarea></label>
      <div class="ro-actions">
        <button type="button" class="pu-btn" (click)="mailEdit = null">Mégse</button>
        <button type="button" class="pu-btn pu-btn--dark" (click)="sendMail(o)" [disabled]="busy[o.id]">Küldés: {{ o.supplier?.email }}</button>
      </div>
    </div>

    <div class="ro-actions" *ngIf="mailEdit?.id !== o.id">
      <a class="pu-btn pu-btn--sm" *ngIf="o.mailThreadId" [routerLink]="['/beszerzes/levelezes']" [queryParams]="{ thread: o.mailThreadId }">Levelezés</a>
      <ng-container *ngIf="o.status === 'pending'">
        <span class="pu-muted" *ngIf="!isAdmin">Jóváhagyásra vár (admin).</span>
        <button type="button" class="pu-btn pu-btn--accent" *ngIf="isAdmin" (click)="approve(o)" [disabled]="busy[o.id]">Jóváhagyom</button>
      </ng-container>
      <ng-container *ngIf="o.status === 'approved'">
        <ng-container *ngIf="o.supplier?.orderMethod === 'email'">
          <span class="pu-muted">Foxi küldi a rendelő levelet — vagy küldd el te:</span>
          <button type="button" class="pu-btn pu-btn--sm" (click)="openMail(o)">Levél küldése…</button>
        </ng-container>
        <ng-container *ngIf="o.supplier?.orderMethod === 'webshop'">
          <button type="button" class="pu-btn pu-btn--accent" *ngIf="isAdmin && o.robotRun?.status === 'ready' && !o.robotConfirmed" (click)="robotGo(o)" [disabled]="busy[o.id]">Leadhatja (robot)</button>
          <button type="button" class="pu-btn pu-btn--dark" *ngIf="o.robotRun?.status !== 'running' && !(o.robotRun?.status === 'ready' && !o.robotConfirmed)" (click)="startRobot(o)" [disabled]="busy[o.id]">{{ o.robotRun ? 'Robot újra' : 'Rendelés robottal' }}</button>
          <details class="ro-manual">
            <summary>Kézzel adom le</summary>
            <a class="pu-btn pu-btn--sm" *ngIf="o.supplier?.website" [href]="o.supplier!.website!" target="_blank" rel="noopener">Webshop megnyitása</a>
            <input class="pu-input ro-ref" [(ngModel)]="refEdit[o.id]" placeholder="Webshop rendelésszám (ha van)">
            <button type="button" class="pu-btn pu-btn--sm" (click)="markOrdered(o)" [disabled]="busy[o.id]">Leadtam a webshopban</button>
          </details>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="o.status === 'sent' || o.status === 'confirmed' || o.status === 'shipped'">
        <button type="button" class="pu-btn pu-btn--sm" *ngIf="o.status === 'sent'" (click)="setStatus(o, 'confirmed')" [disabled]="busy[o.id]">Visszaigazolva</button>
        <button type="button" class="pu-btn pu-btn--sm" *ngIf="o.status !== 'shipped'" (click)="setStatus(o, 'shipped')" [disabled]="busy[o.id]">Feladva</button>
        <button type="button" class="pu-btn pu-btn--accent" (click)="receive(o)" [disabled]="busy[o.id]">Megjött 📦</button>
      </ng-container>
      <button type="button" class="pu-btn pu-btn--sm pu-btn--danger" *ngIf="isAdmin && o.status !== 'received' && o.status !== 'cancelled' && !canDelete(o)" (click)="cancel(o)" [disabled]="busy[o.id]">Lemondás</button>
      <button type="button" class="pu-btn pu-btn--sm pu-btn--danger" *ngIf="canDelete(o)" (click)="remove(o)" [disabled]="busy[o.id]">Törlés</button>
    </div>
  </div>
</div>
